import { getCurrencyStr } from '../getCurrencyStr';
export var getCurrencyRangeStr = function (currencyRange, options) {
    var max = currencyRange.max, min = currencyRange.min;
    var maxCurrencyStr = getCurrencyStr(max, {
        forceRationalFormatting: options === null || options === void 0 ? void 0 : options.forceRationalFormatting
    });
    var minCurrencyStr = getCurrencyStr(min, {
        forceRationalFormatting: options === null || options === void 0 ? void 0 : options.forceRationalFormatting
    });
    if (maxCurrencyStr === null || minCurrencyStr === null) {
        return null;
    }
    else if (maxCurrencyStr === minCurrencyStr) {
        return minCurrencyStr;
    }
    else if (options === null || options === void 0 ? void 0 : options.rangeMinimum) {
        return "".concat(minCurrencyStr, "+");
    }
    return "".concat(minCurrencyStr, " - ").concat(maxCurrencyStr);
};
